
import React from "react";
import { User, Mail, MapPin } from "lucide-react";
import FormField from "./FormField";
import PasswordField from "./PasswordField";
import SubmitButton from "./SubmitButton";

type SignupFormProps = {
  formData: {
    fullName: string;
    email: string;
    password: string;
    country?: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  formErrors?: {
    [key: string]: string;
  };
  locationDetected?: boolean;
};

const SignupForm = ({ 
  formData, 
  handleChange, 
  isLoading, 
  formErrors,
  locationDetected 
}: SignupFormProps) => {
  return (
    <>
      <FormField
        id="fullName"
        label="Full Name"
        placeholder="John Doe"
        value={formData.fullName}
        onChange={handleChange}
        required
        minLength={2}
        icon={<User />}
        error={formErrors?.fullName}
      />

      <FormField
        id="email"
        label="Email"
        type="email"
        placeholder="example@email.com"
        value={formData.email}
        onChange={handleChange}
        required
        icon={<Mail />}
        error={formErrors?.email}
      />

      <PasswordField
        id="password"
        label="Password"
        placeholder="••••••••"
        value={formData.password}
        onChange={handleChange}
        required
        minLength={8}
        error={formErrors?.password}
        showStrengthIndicator={true}
      />

      {formData.country && (
        <div className="flex items-center space-x-2 text-sm text-muted-foreground mt-2 mb-4">
          <MapPin className="h-4 w-4" />
          <span>
            Location {locationDetected ? "detected" : "set"} as <strong>{formData.country}</strong>
          </span>
        </div>
      )}

      <SubmitButton isLoading={isLoading} text="Create Account" />
    </>
  );
};

export default SignupForm;
